// The order tables are listed in on the grid views (floor tabs, Person, Pager, Finalise): 1, 2, 3 ... 10, 11, not 1, 10, 11, 2.
// The server sends them in plain text order, so the POS sorts them. The key is the table's own name or number, never what a tile shows while
// the table is occupied (a customer or order name replaces it). Names that start with a number come first, in number order; names with letters
// follow in natural order (B1, B5, B10), and equal names keep a fixed order by id.

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export const tableKey = (t) => String(t?.name ?? t?.tableNumber ?? '').trim();

export function compareTables(a, b) {
  const ka = tableKey(a);
  const kb = tableKey(b);
  const na = /^\d/.test(ka);
  const nb = /^\d/.test(kb);
  if (na !== nb) return na ? -1 : 1;
  const c = collator.compare(ka, kb);
  if (c !== 0) return c;
  if (ka !== kb) return ka < kb ? -1 : 1;
  return (Number(a?.id) || 0) - (Number(b?.id) || 0);
}

/** A sorted copy of a list of tables (the input is left as it is). */
export const sortTables = (list) => (Array.isArray(list) ? [...list].sort(compareTables) : list);

/** The same for every tab of a { tabId: [tables] } map. */
export function sortTableData(data) {
  const out = {};
  Object.keys(data || {}).forEach((k) => { out[k] = sortTables(data[k]); });
  return out;
}
